export const SET_PROFILE = 'userProfile/SET_PROFILE'
export const UPDATE_BRAND_SUBSCRIPTIONS = 'userProfile/UPDATE_BRAND_SUBSCRIPTIONS'
export const USER_PROFILE_LOADED = 'userProfile/LOADED'
export const USER_PROFILE_LOAD_ERROR = 'userProfile/LOAD_ERROR'
